let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gCaMW")).then(() => parcelRequire('9pRVg'));